module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/my/privilege_3_on.png";